import { useReFetchBoxItems } from 'hooks/api/box';
import { useMutateSalesDemo } from 'hooks/api/salesDemo';
import { useRefetchSubmissionEmails } from 'hooks/api/submissionEmail';
import { RouteKey } from 'broker/enums';
import { useNavigate } from 'broker/hooks';
import { useWorkspaceUrls } from 'broker/pages/SubmissionWorkspacePage/hooks/useWorkspaceUrls';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';
import { createCyberDemoSteps } from './steps/cyber-demo-steps';
import { createInterwestDemoSteps } from './steps/interwest-demo-steps';
import { useGetFilesAndEmails } from './useGetFilesAndEmails';

interface UseGetRenewalDemoStepsProps {
  onClose: () => void;
}

export function useGetRenewalDemoSteps({ onClose }: UseGetRenewalDemoStepsProps) {
  const { partialSubmission, markets, reFetchWorkspace, updateSubmissionMarketRequest } = useSubmissionsWorkspace();
  const { fetchFromAMS, marketViaAPI, marketViaEmail, marketViaPortal, receiveQuotes, createProposal, writeToAMS } =
    useMutateSalesDemo();
  useMutateSalesDemo();
  const { reFetchFileItems } = useReFetchBoxItems();
  const { reFetchSubmissionEmails } = useRefetchSubmissionEmails();
  const { application, isLoading, expiringPolicy, marketingEmails, marketQuotes, proposalFile, renewalPolicy } =
    useGetFilesAndEmails(partialSubmission);
  const navigate = useNavigate();
  const { proposalFlowUrl } = useWorkspaceUrls();

  const navigateToProposal = () => {
    navigate(proposalFlowUrl, {
      routeKey: RouteKey.ProposalFlow,
      state: undefined,
    });
  };

  const getDemoSteps = () => {
    if (!partialSubmission) {
      return [];
    }

    if (partialSubmission.organizationName.toLowerCase().includes('interwest')) {
      return createInterwestDemoSteps({
        submissionId: partialSubmission.id,
        markets,
        reFetchWorkspace,
        updateSubmissionMarketRequest,
        fetchFromAMS,
        marketViaEmail,
        marketViaPortal,
        receiveQuotes,
        createProposal,
        reFetchFileItems,
        reFetchSubmissionEmails,
        expiringPolicy,
        renewalPolicy,
        application,
        marketQuotes,
        proposalFile,
        marketingEmails,
        onClose,
        navigateToProposal,
      });
    }

    return createCyberDemoSteps({
      submissionId: partialSubmission.id,
      markets,
      reFetchWorkspace,
      updateSubmissionMarketRequest,
      fetchFromAMS,
      marketViaAPI,
      marketViaEmail,
      marketViaPortal,
      receiveQuotes,
      createProposal,
      reFetchFileItems,
      reFetchSubmissionEmails,
      expiringPolicy,
      application,
      marketQuotes,
      proposalFile,
      marketingEmails,
      onClose,
      navigateToProposal,
      writeToAMS,
    });
  };

  return { demoSteps: getDemoSteps(), isLoading };
}
